import { html, nothing, render } from "lit-html"
import Modal from "../generic/modal"

export default function renderAugmentation(el) {
  const formEl = el.closest("form")
  const confirmFormId = "augmentation-confirm"
  const confirmFormWrapperId = `${confirmFormId}-wrapper`
  const $augmentationConfirmButton = formEl.querySelector(
    `#${confirmFormId}-button`
  )

  const $modalMount = document.getElementById("modal-mount")

  const onCloseModal = () => {
    formEl.removeAttribute("id")
    render(nothing, $modalMount)
  }

  const showConfirmModal = () => {
    const confirmModal = Modal({
      onClose: onCloseModal,
      children: html`<div id="${confirmFormWrapperId}"></div>`,
    })
    render(confirmModal, $modalMount)
    setTimeout(() => {
      formEl.setAttribute("id", confirmFormId)
      $augmentationConfirmButton.click()
    }, 0)
  }

  $modalMount.addEventListener("click", (e) => {
    if (e.target.closest("[data-close-modal]")) {
      onCloseModal()
    }
  })

  formEl.addEventListener("submit", (e) => {
    const isConfirmed = formEl.getAttribute("id") == confirmFormId
    if (!isConfirmed) {
      e.preventDefault()
      showConfirmModal()
    }
  })
}
